import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { StationsPage } from "@/features/charging-stations/pages/stations-page";
import { stationsFilterSchema } from "@/features/charging-stations/schemas/stations-filter-schema";

export const Route = createFileRoute(
	"/_authenticated/admin/charging/stations/"
)({
	head: () => pageTitle("Charging Stations"),
	component: StationsPage,
	validateSearch: zodValidator(stationsFilterSchema),
});
